import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { actions } from 'reducers';

const mapStateToProps = (state, { id }) => ({
  event: state.collections.events[id] || {},
  content: state.collections.content || {},
  isActive: state.schedule.activeEventId === id,
  isNew: state.schedule.newEventId === id
});

const mapDispatchToProps = {
  setActiveEvent: actions.schedule.setActiveEvent,
  deleteOne: actions.collections.deleteOne,
  updateOne: actions.collections.updateOne
};

const makeProps = props => ({
  setActiveEvent: () => props.setActiveEvent(props.id),
  removeEvent: () =>
    props.deleteOne({
      collectionName: 'events',
      id: props.id
    }),
  setStartDate: date =>
    props.updateOne({
      collectionName: 'events',
      id: props.id,
      fields: {
        startDate: date.toDate().getTime()
      }
    }),
  setEndDate: date =>
    props.updateOne({
      collectionName: 'events',
      id: props.id,
      fields: {
        endDate: date.toDate().getTime()
      }
    }),
  piece: props.content[props.event.contentId] || {}
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(makeProps)
);



// WEBPACK FOOTER //
// ./src/components/schedule/schedule-item/enhance.js